import React, {FC} from 'react';

import {useGetStoreInfoValues} from 'desktop/hooks/useGetStoreInfoValues/useGetStoreInfoValues';

import {ContinueShoppingButton} from '../continueShoppingButton/continueShoppingButton';

import s from '../successMessageWithDash.scss';

export type PropsType = {
    isCopyOfPrescription?: boolean;
};

/**
 * Success screen on contact lenses
 * @param {boolean} isCopyOfPrescription - if true then component shows
 * send us a copy of your prescription message
 * @returns {React.ReactNode} react template
 */
export const DontForgetToSendUsYourDetailsOrPrescription: FC<PropsType> = ({
    isCopyOfPrescription,
}) => {
    const {fax, prescriptionEmail} = useGetStoreInfoValues();
    return (
        <div className={s.wrapper}>
            <p className={s.descriptionTop}>
                {isCopyOfPrescription ? (
                    <strong>
                        Don&apos;t forget to send us a copy of your prescription - <br /> we
                        can&apos;t ship your contacts without it!
                    </strong>
                ) : (
                    <strong>
                        Don&apos;t forget to send us your Dr. details - <br />
                        we can&apos;t ship your contacts without them!
                    </strong>
                )}
            </p>
            <div className={s.dash} />
            <p className={s.descriptionBottom}>
                You can send it via email or fax.
                <br /> Email: <span className={s.contacts}>{prescriptionEmail}</span>, Fax:{' '}
                <span className={s.contacts}>{fax}</span>
            </p>
            <ContinueShoppingButton />
        </div>
    );
};
